import styled from 'styled-components';

const NumIconSmWithoutNum = styled.div`
  font-size: 13px;
  margin: auto 0;
  z-index: 1;
  padding: 3px 20px 3px 4px;
  border-radius: 14px;
  border: solid 1px #0658a9;
  color: #fff;
  background-color: #0658a9;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  ::before {
    content: counter(section);
    width: 18px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 50%;
    background: #0658a9;
    color: #0658a9;
    font-size: 11px;
    font-weight: 400;
  }
`;

export default NumIconSmWithoutNum;
